//  to remove later
import { HTTP_VERBS } from "../../enums";
import { AcpWithdrawlDTO } from "../domainObjects/acpWithdrawalV3";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v3/acp/withdraw";

export class Body extends AcpWithdrawlDTO {}

export class Response {
	errorCode!: string | null;
	Status!: "Success" | "Failed";
	Message!: string;
	RequestID!: string;
}
